import sliceCreator from '../../index.jsx';
import {CREATE_VILLAGE} from '../../../constants/index.jsx';
const _createVillageAction = sliceCreator('CREATE_VILLAGE', CREATE_VILLAGE, 'post');

const { asyncAction: createVillageAction, reducer, clearData: clearCreateVillageAction } = _createVillageAction;

export default reducer;

export {
    createVillageAction,
    clearCreateVillageAction
}